"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentManifest = void 0;
const manifest = {
    'mm-accent-tag': [
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-add-button': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-ai-chat-bubble': [
        {
            name: 'typing',
            type: 'boolean = false',
        },
        {
            name: 'src',
            type: 'string',
            optional: true,
        },
    ],
    'mm-ai-chat-message': [
        {
            name: 'datetime',
            type: 'string',
            optional: true,
        },
        {
            name: 'hidden-reactions',
            type: 'boolean = false',
        },
    ],
    'mm-attachment-button': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'accept',
            type: 'string',
            optional: true,
        },
        {
            name: 'multiple',
            type: 'boolean = false',
        },
        {
            name: 'capture',
            type: 'boolean = false',
        },
    ],
    'mm-attachment-item': [
        {
            name: 'file-name',
            type: 'string',
            optional: true,
        },
        {
            name: 'file-size',
            type: 'string',
            optional: true,
        },
        {
            name: 'preview-url',
            type: 'string',
            optional: true,
        },
        {
            name: 'type',
            type: 'string',
            optional: true,
        },
        {
            name: 'progress',
            type: 'number',
            optional: true,
        },
        {
            name: 'error',
            type: 'string',
            optional: true,
        },
    ],
    'mm-avatar': [
        {
            name: 'variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'primary'",
        },
        {
            name: 'size',
            type: "'80' | '48' | '40' | '32' = '40'",
        },
        {
            name: 'shape',
            type: "'circle' | 'square' = 'square'",
        },
        {
            name: 'src',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-avatar-group': [
        {
            name: 'avatars',
            type: 'AvatarItem[] = []',
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-backdrop': [],
    'mm-banner': [
        {
            name: 'variant',
            type: "'primary'",
            optional: true,
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
    ],
    'mm-bookmark-button': [
        {
            name: 'pressed',
            type: 'boolean = false',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'shape',
            type: "'star' | 'bookmark' | 'heart' = 'star'",
        },
    ],
    'mm-bottom-bar': [
        {
            name: 'items',
            type: 'BottomBarItem[]',
        },
        {
            name: 'aria-label',
            type: "string = '하단 내비게이션'",
        },
    ],
    'mm-breadcrumb': [
        {
            name: 'items',
            type: 'BreadcrumbItem[] = []',
        },
        {
            name: 'aria-label',
            type: "string = 'breadcrumb'",
        },
        {
            name: 'divider',
            type: "string = '/'",
        },
    ],
    'mm-button': [
        {
            name: 'variant',
            type: "'primary' | 'secondary' | 'tertiary' | 'ghost' | 'danger' = 'tertiary'",
        },
        {
            name: 'size',
            type: "'medium' | 'large' = 'medium'",
        },
        {
            name: 'full-width',
            type: 'boolean = false',
        },
        {
            name: 'type',
            type: "'button' | 'submit' | 'reset' = 'button'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'icon-position',
            type: "'leading' | 'trailing' = 'leading'",
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
        {
            name: 'aria-expanded',
            type: "'true' | 'false'",
            optional: true,
        },
        {
            name: 'aria-haspopup',
            type: "'true' | 'false' | 'menu' | 'listbox' | 'tree' | 'grid' | 'dialog'",
            optional: true,
        },
        {
            name: 'aria-controls',
            type: 'AriaIdRef',
            optional: true,
        },
        {
            name: 'aria-current',
            type: "'true' | 'false' | 'page' | 'step' | 'location' | 'date' | 'time'",
            optional: true,
        },
    ],
    'mm-button-group': [
        {
            name: 'direction',
            type: "'row' | 'column' = 'row'",
        },
        {
            name: 'justify-content',
            type: "'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' = 'flex-start'",
        },
        {
            name: 'stretch',
            type: 'boolean = false',
        },
    ],
    'mm-caption': [],
    'mm-cast-list': [
        {
            name: 'casts',
            type: 'CastMember[] = []',
        },
    ],
    'mm-category-tag': [
        {
            name: 'tone',
            type: "'pink' | 'orange' | 'cyan' | 'purple' = 'pink'",
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-chart-column': [
        {
            name: 'items',
            type: 'ChartColumnItem[] = []',
        },
        {
            name: 'selectable',
            type: 'boolean = false',
        },
        {
            name: 'selected',
            type: 'string',
            optional: true,
        },
    ],
    'mm-chart-legend': [
        {
            name: 'items',
            type: 'ChartLegendItem[] = []',
        },
    ],
    'mm-chart-progress-ring': [
        {
            name: 'value',
            type: 'number = 0',
        },
    ],
    'mm-chart-stacked-bar': [
        {
            name: 'items',
            type: 'ChartStackedBarItem[] = []',
        },
    ],
    'mm-chat-body': [],
    'mm-chat-confirmation': [
        {
            name: 'status',
            type: "'pending' | 'accepted' | 'rejected' = 'pending'",
        },
        {
            name: 'message',
            type: 'string',
            optional: true,
        },
    ],
    'mm-chat-date': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-chat-feed': [],
    'mm-chat-footer': [],
    'mm-chat-header': [],
    'mm-chat-reasoning': [
        {
            name: 'thinking',
            type: 'boolean = false',
        },
        {
            name: 'duration',
            type: 'string',
            optional: true,
        },
    ],
    'mm-chat-reasoning-flow': [
        {
            name: 'active',
            type: 'boolean = false',
        },
        {
            name: 'tone',
            type: "'thinking' | 'searching' | 'reading' | 'writing' = 'thinking'",
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-chat-room': [],
    'mm-chat-source': [
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-chat-suggestion': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-chat-suggestions': [],
    'mm-checkbox': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'medium' | 'large' = 'medium'",
        },
        {
            name: 'checked',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'indeterminate',
            type: 'boolean = false',
        },
    ],
    'mm-checkbox-group': [
        {
            name: 'options',
            type: 'OptionItem[] = []',
        },
        {
            name: 'values',
            type: 'string[] = []',
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'medium' | 'large' = 'medium'",
        },
        {
            name: 'legend',
            type: 'string',
            optional: true,
        },
    ],
    'mm-clear-button': [
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-close-button': [
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-code': [],
    'mm-code-block': [
        {
            name: 'variant',
            type: "'default' | 'plain' = 'default'",
        },
        {
            name: 'code',
            type: 'string',
            optional: true,
        },
        {
            name: 'language',
            type: "string = 'markup'",
        },
        {
            name: 'copyable',
            type: 'boolean = true',
        },
    ],
    'mm-color-token': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'pairs',
            type: 'string[] = []',
        },
    ],
    'mm-comment-input': [
        {
            name: 'name',
            type: "string = 'comment'",
        },
        {
            name: 'placeholder',
            type: 'string',
            optional: true,
        },
        {
            name: 'submit-label',
            type: "string = '댓글 게시'",
        },
    ],
    'mm-comment-item': [
        {
            name: 'author',
            type: 'string',
            optional: true,
        },
        {
            name: 'datetime',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'reply-label',
            type: 'string',
            optional: true,
        },
        {
            name: 'editable',
            type: 'boolean = false',
        },
    ],
    'mm-comment-list': [],
    'mm-component-aka': [
        {
            name: 'items',
            type: 'string[] = []',
        },
    ],
    'mm-component-anatomy': [
        {
            name: 'heading',
            type: "string = 'Anatomy'",
        },
        {
            name: 'parts',
            type: 'string[] = []',
        },
        {
            name: 'markers',
            type: 'AnatomyMarkerData[] = []',
        },
        {
            name: 'code',
            type: 'string',
            optional: true,
        },
        {
            name: 'full-width',
            type: 'boolean = false',
        },
    ],
    'mm-component-changelog': [
        {
            name: 'heading',
            type: "string = 'Changelog'",
        },
        {
            name: 'items',
            type: 'ComponentChangelogItemData[] = []',
        },
    ],
    'mm-component-example': [
        {
            name: 'width',
            type: "'narrow' | ''",
            optional: true,
        },
        {
            name: 'full-width',
            type: 'boolean = false',
        },
    ],
    'mm-component-feature-list': [
        {
            name: 'features',
            type: 'ComponentFeatureItem[] = []',
        },
    ],
    'mm-component-guide': [
        {
            name: 'features',
            type: 'ComponentFeatureItem[] = []',
        },
    ],
    'mm-component-notice': [
        {
            name: 'variant',
            type: "'todo' | 'exception' = 'todo'",
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
    ],
    'mm-component-pager': [],
    'mm-component-prop-item': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'type',
            type: 'string',
            optional: true,
        },
        {
            name: 'kind',
            type: "'event'",
            optional: true,
        },
        {
            name: 'optional',
            type: 'boolean = false',
        },
    ],
    'mm-component-props': [
        {
            name: 'props',
            type: 'ComponentPropItemData[] = []',
        },
        {
            name: 'open',
            type: 'boolean = false',
        },
    ],
    'mm-component-references': [
        {
            name: 'heading',
            type: "string = 'References'",
        },
        {
            name: 'items',
            type: '| ComponentReferenceItemData[] | ComponentReferenceItemData[][] = []',
        },
    ],
    'mm-component-related': [
        {
            name: 'heading',
            type: "string = 'Related'",
        },
        {
            name: 'items',
            type: 'ComponentRelatedItemData[] = []',
        },
    ],
    'mm-component-section': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'code',
            type: 'string',
            optional: true,
        },
        {
            name: 'width',
            type: "'narrow' | ''",
            optional: true,
        },
        {
            name: 'full-width',
            type: 'boolean = false',
        },
    ],
    'mm-component-tokens': [
        {
            name: 'elements',
            type: 'string[] = []',
        },
    ],
    'mm-component-usage': [
        {
            name: 'items',
            type: 'ComponentUsageItem[] = []',
        },
    ],
    'mm-content-section': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'heading-level',
            type: 'number = 2',
        },
    ],
    'mm-content-section-list': [],
    'mm-copy-button': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
    ],
    'mm-current-indicator': [],
    'mm-delete-button': [
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-dialog': [
        {
            name: 'open',
            type: 'boolean = false',
        },
        {
            name: 'aria-modal',
            type: "'true' | 'false' = 'true'",
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'primaryAction',
            type: 'ActionConfig',
            optional: true,
        },
        {
            name: 'secondaryAction',
            type: 'ActionConfig',
            optional: true,
        },
    ],
    'mm-dismiss-button': [
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-dot': [
        {
            name: 'tone',
            type: "'default' | 'gold' | 'green' | 'yellow' | 'red' | 'blue' | 'purple' | 'pink' | 'orange' | 'cyan' | 'gray' = 'default'",
        },
        {
            name: 'size',
            type: "'16' | '12' | '8' | '6' = '8'",
        },
    ],
    'mm-expand-indicator': [
        {
            name: 'expanded',
            type: 'boolean = false',
        },
    ],
    'mm-faq-item': [
        {
            name: 'question',
            type: 'string',
            optional: true,
        },
        {
            name: 'open',
            type: 'boolean = false',
        },
    ],
    'mm-faq-list': [],
    'mm-feature': [
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'centered',
            type: 'boolean = false',
        },
    ],
    'mm-feature-group': [
        {
            name: 'columns',
            type: 'Exclude<GridColumns, 6> = 2',
        },
    ],
    'mm-file-uploader': [
        {
            name: 'label',
            type: "string = '파일 업로드'",
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'accept',
            type: 'string',
            optional: true,
        },
        {
            name: 'multiple',
            type: 'boolean = false',
        },
        {
            name: 'capture',
            type: 'boolean = false',
        },
    ],
    'mm-filter-button-group': [
        {
            name: 'mode',
            type: "'single' | 'multiple' = 'single'",
        },
        {
            name: 'values',
            type: 'string[] = []',
        },
        {
            name: 'options',
            type: 'FilterOption[] = []',
        },
        {
            name: 'orientation',
            type: "'horizontal' | 'vertical' = 'horizontal'",
        },
    ],
    'mm-fixed-bottom': [],
    'mm-fixed-top': [],
    'mm-flex': [
        {
            name: 'direction',
            type: "'row' | 'column' = 'row'",
        },
        {
            name: 'justify-content',
            type: "'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' = 'flex-start'",
        },
        {
            name: 'align-items',
            type: "'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline' = 'stretch'",
        },
        {
            name: 'gap',
            type: "'16' | '12' | '8' | '6' | '0' | '1' | '2' | '3' | '4' | 'section' = '0'",
        },
        {
            name: 'as',
            type: "'div' | 'header' | 'section' | 'footer' | 'nav' = 'div'",
        },
        {
            name: 'wrap',
            type: "'nowrap' | 'wrap' | 'wrap-reverse' = 'nowrap'",
        },
        {
            name: 'stretch',
            type: 'boolean = false',
        },
    ],
    'mm-flex-preview': [],
    'mm-follow-button': [
        {
            name: 'pressed',
            type: 'boolean = false',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-footer': [],
    'mm-form-field': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'validation-text',
            type: 'string',
            optional: true,
        },
        {
            name: 'optional',
            type: 'boolean = false',
        },
    ],
    'mm-foundation-item': [
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
    ],
    'mm-gender-selector': [
        {
            name: 'value',
            type: "'other' | 'female' | 'male' = 'other'",
        },
        {
            name: 'stretch',
            type: 'boolean = false',
        },
    ],
    'mm-grid': [
        {
            name: 'columns',
            type: 'GridColumns = 2',
        },
        {
            name: 'column-min-width',
            type: 'string',
            optional: true,
        },
        {
            name: 'gap',
            type: "'16' | '12' | '8' | '6' | '0' | '1' | '2' | '3' | '4' | 'section' = '4'",
        },
    ],
    'mm-grid-preview': [],
    'mm-hamburger-button': [
        {
            name: 'aria-label',
            type: "string = '전체 메뉴'",
        },
        {
            name: 'aria-expanded',
            type: "'true' | 'false' = 'false'",
        },
        {
            name: 'aria-controls',
            type: 'AriaIdRef',
            optional: true,
        },
    ],
    'mm-hashtag-link': [
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
    ],
    'mm-heading': [
        {
            name: 'level',
            type: 'HeadingLevel = 2',
        },
    ],
    'mm-icon': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'small' | 'medium' | 'large' | 'tiny' = 'medium'",
        },
    ],
    'mm-icon-button': [
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'variant',
            type: "'primary' | 'secondary' | 'tertiary' | 'ghost' | 'danger' = 'tertiary'",
        },
        {
            name: 'size',
            type: "'small' | 'medium' = 'medium'",
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-haspopup',
            type: "'true' | 'false' | 'menu' | 'listbox' | 'tree' | 'grid' | 'dialog'",
            optional: true,
        },
        {
            name: 'aria-expanded',
            type: "'true' | 'false'",
            optional: true,
        },
        {
            name: 'aria-controls',
            type: 'AriaIdRef',
            optional: true,
        },
    ],
    'mm-input': [
        {
            name: 'input-id',
            type: 'string',
            optional: true,
        },
        {
            name: 'type',
            type: "'text' | 'search' | 'tel' | 'url' | 'email' | 'password' | 'number' | 'date' | 'time' | 'datetime-local' | 'month' | 'week' | 'color' | 'hidden' = 'text'",
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'placeholder',
            type: 'string',
            optional: true,
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-invalid',
            type: "'true' | 'false' | 'grammar' | 'spelling'",
            optional: true,
        },
        {
            name: 'aria-describedby',
            type: 'AriaIdRef',
            optional: true,
        },
        {
            name: 'min',
            type: 'number',
            optional: true,
        },
        {
            name: 'max',
            type: 'number',
            optional: true,
        },
        {
            name: 'step',
            type: 'number',
            optional: true,
        },
    ],
    'mm-keyword-tag': [
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-keyword-tag-group': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'keywords',
            type: 'string[] = []',
        },
    ],
    'mm-link': [
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'target',
            type: 'string',
            optional: true,
        },
        {
            name: 'external',
            type: 'boolean = false',
        },
    ],
    'mm-link-prompt': [
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'message',
            type: 'string',
            optional: true,
        },
        {
            name: 'link-label',
            type: 'string',
            optional: true,
        },
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'external',
            type: 'boolean = false',
        },
    ],
    'mm-list-item': [
        {
            name: 'size',
            type: "'small' | 'medium' | 'large' = 'small'",
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'primary'",
        },
        {
            name: 'avatar-shape',
            type: "'circle' | 'square' = 'square'",
        },
    ],
    'mm-list-item-group': [
        {
            name: 'role',
            type: "'list' | 'group' = 'list'",
        },
        {
            name: 'gap',
            type: "'0' | '3' = '3'",
        },
    ],
    'mm-list-marker': [
        {
            name: 'variant',
            type: "'number' | 'check' = 'number'",
        },
        {
            name: 'value',
            type: 'number = 1',
        },
    ],
    'mm-main': [
        {
            name: 'width',
            type: "'small' | 'narrow' | ''",
            optional: true,
        },
        {
            name: 'layout',
            type: "'chat' | 'split' | ''",
            optional: true,
        },
        {
            name: 'background',
            type: "'subtle' | ''",
            optional: true,
        },
        {
            name: 'full-width',
            type: 'boolean = false',
        },
    ],
    'mm-marquee': [
        {
            name: 'direction',
            type: "'left' | 'right' = 'left'",
        },
        {
            name: 'gap',
            type: "'16' | '12' | '8' | '6' | '0' | '1' | '2' | '3' | '4' | 'section' = '4'",
        },
        {
            name: 'height',
            type: 'string',
            optional: true,
        },
        {
            name: 'speed',
            type: 'number = 80',
        },
        {
            name: 'pause-on-hover',
            type: 'boolean = false',
        },
    ],
    'mm-media-card': [
        {
            name: 'title',
            type: 'string',
            optional: true,
        },
        {
            name: 'subtitle',
            type: 'string',
            optional: true,
        },
        {
            name: 'director',
            type: 'string',
            optional: true,
        },
        {
            name: 'country',
            type: 'string',
            optional: true,
        },
        {
            name: 'year',
            type: 'string',
            optional: true,
        },
    ],
    'mm-media-filter': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'options',
            type: 'FilterOption[] = []',
        },
    ],
    'mm-media-list': [
        {
            name: 'items',
            type: 'MediaItem[] = []',
        },
        {
            name: 'filters',
            type: 'MediaListFilter[] = []',
        },
        {
            name: 'unit',
            type: 'string',
            optional: true,
        },
    ],
    'mm-menu-item-action': [
        {
            name: 'size',
            type: "'small' | 'medium' = 'small'",
        },
        {
            name: 'tone',
            type: "'' | 'danger'",
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'tertiary'",
        },
        {
            name: 'avatar-shape',
            type: "'circle' | 'square' = 'square'",
        },
        {
            name: 'trailing-icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-menu-item-checkbox': [
        {
            name: 'size',
            type: "'small' | 'medium' = 'small'",
        },
        {
            name: 'tone',
            type: "'' | 'danger'",
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'tertiary'",
        },
        {
            name: 'avatar-shape',
            type: "'circle' | 'square' = 'square'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'checked',
            type: 'boolean = false',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
    ],
    'mm-menu-item-checkbox-group': [
        {
            name: 'size',
            type: "'medium' | 'large' = 'medium'",
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
        {
            name: 'values',
            type: 'string[] = []',
        },
    ],
    'mm-menu-item-group': [
        {
            name: 'role',
            type: "'menu' | 'radiogroup' | 'group' = 'menu'",
        },
        {
            name: 'size',
            type: "'medium' | 'large' = 'medium'",
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
    ],
    'mm-menu-item-link': [
        {
            name: 'size',
            type: "'small' | 'medium' = 'small'",
        },
        {
            name: 'tone',
            type: "'' | 'danger'",
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'tertiary'",
        },
        {
            name: 'avatar-shape',
            type: "'circle' | 'square' = 'square'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'target',
            type: "string = '_blank'",
        },
    ],
    'mm-menu-item-radio': [
        {
            name: 'size',
            type: "'small' | 'medium' = 'small'",
        },
        {
            name: 'tone',
            type: "'' | 'danger'",
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'tertiary'",
        },
        {
            name: 'avatar-shape',
            type: "'circle' | 'square' = 'square'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'checked',
            type: 'boolean = false',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
    ],
    'mm-menu-item-radio-group': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'medium' | 'large' = 'medium'",
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-menu-item-switch': [
        {
            name: 'size',
            type: "'small' | 'medium' = 'small'",
        },
        {
            name: 'tone',
            type: "'' | 'danger'",
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'tertiary'",
        },
        {
            name: 'avatar-shape',
            type: "'circle' | 'square' = 'square'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'checked',
            type: 'boolean = false',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
    ],
    'mm-meta-item': [
        {
            name: 'layout',
            type: "'horizontal' | 'stacked' | 'inline' = 'horizontal'",
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'value-size',
            type: "'medium' | 'large' = 'medium'",
        },
    ],
    'mm-meta-item-group': [
        {
            name: 'direction',
            type: "'row' | 'column' = 'row'",
        },
        {
            name: 'gap',
            type: "'2' | '3' | '4' | '8' = '4'",
        },
        {
            name: 'wrap',
            type: "'nowrap' | 'wrap' | 'wrap-reverse' = 'nowrap'",
        },
    ],
    'mm-model-selector': [
        {
            name: 'value',
            type: "string = 'claude-sonnet'",
        },
    ],
    'mm-more-button': [
        {
            name: 'aria-label',
            type: "string = '더보기'",
        },
        {
            name: 'aria-expanded',
            type: "'true' | 'false' = 'false'",
        },
        {
            name: 'aria-controls',
            type: 'AriaIdRef',
            optional: true,
        },
        {
            name: 'aria-haspopup',
            type: "'true' | 'false' | 'menu' | 'listbox' | 'tree' | 'grid' | 'dialog' = 'menu'",
        },
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-more-menu': [
        {
            name: 'actions',
            type: 'MoreMenuAction[] = []',
        },
        {
            name: 'placement',
            type: "'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' = 'bottom-end'",
        },
        {
            name: 'aria-label',
            type: "string = '더보기'",
        },
    ],
    'mm-my-chat-bubble': [
        {
            name: 'typing',
            type: 'boolean = false',
        },
        {
            name: 'src',
            type: 'string',
            optional: true,
        },
        {
            name: 'status',
            type: 'string',
            optional: true,
        },
    ],
    'mm-my-chat-message': [
        {
            name: 'datetime',
            type: 'string',
            optional: true,
        },
        {
            name: 'failed',
            type: 'boolean = false',
        },
    ],
    'mm-navbar': [],
    'mm-navbar-search': [],
    'mm-next-button': [
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'size',
            type: "'small' | 'medium' = 'medium'",
        },
    ],
    'mm-notice': [
        {
            name: 'role',
            type: "'alert' | 'note' | 'status' = 'note'",
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'variant',
            type: "'info' | 'success' | 'warning' | 'error' = 'info'",
        },
        {
            name: 'primaryAction',
            type: 'ActionConfig',
            optional: true,
        },
        {
            name: 'secondaryAction',
            type: 'ActionConfig',
            optional: true,
        },
    ],
    'mm-numberfield': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'placeholder',
            type: 'string',
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'validation-text',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'small' | 'medium' = 'medium'",
        },
        {
            name: 'optional',
            type: 'boolean = false',
        },
        {
            name: 'hidden-label',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-invalid',
            type: "'true' | 'false' | 'grammar' | 'spelling'",
            optional: true,
        },
        {
            name: 'min',
            type: 'number',
            optional: true,
        },
        {
            name: 'max',
            type: 'number',
            optional: true,
        },
        {
            name: 'step',
            type: 'number = 1',
        },
    ],
    'mm-order-product-item': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'option',
            type: 'string',
            optional: true,
        },
        {
            name: 'price',
            type: 'string',
            optional: true,
        },
        {
            name: 'image-src',
            type: 'string',
            optional: true,
        },
    ],
    'mm-page-body': [],
    'mm-page-button': [
        {
            name: 'page',
            type: 'number = 1',
        },
        {
            name: 'aria-current',
            type: "'true' | 'false' | 'page' | 'step' | 'location' | 'date' | 'time'",
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-page-header': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'centered',
            type: 'boolean = false',
        },
    ],
    'mm-pager': [
        {
            name: 'previous',
            type: 'PagerLink',
            optional: true,
        },
        {
            name: 'next',
            type: 'PagerLink',
            optional: true,
        },
    ],
    'mm-pagination': [
        {
            name: 'current-page',
            type: 'number = 1',
        },
        {
            name: 'page-count',
            type: 'number = 1',
        },
        {
            name: 'aria-label',
            type: "string = 'pagination'",
        },
    ],
    'mm-paragraph': [
        {
            name: 'size',
            type: "'small' | 'medium' | 'large' = 'medium'",
        },
        {
            name: 'color',
            type: "'inherit' | 'light' | 'danger' = 'inherit'",
        },
        {
            name: 'max-lines',
            type: "'' | '1' | '2' | '3'",
            optional: true,
        },
        {
            name: 'centered',
            type: 'boolean = false',
        },
    ],
    'mm-paragraph-group': [],
    'mm-participant-chat-bubble': [
        {
            name: 'typing',
            type: 'boolean = false',
        },
        {
            name: 'src',
            type: 'string',
            optional: true,
        },
    ],
    'mm-participant-chat-message': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'datetime',
            type: 'string',
            optional: true,
        },
    ],
    'mm-passwordfield': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'placeholder',
            type: 'string',
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'validation-text',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'small' | 'medium' = 'medium'",
        },
        {
            name: 'optional',
            type: 'boolean = false',
        },
        {
            name: 'hidden-label',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-invalid',
            type: "'true' | 'false' | 'grammar' | 'spelling'",
            optional: true,
        },
    ],
    'mm-popover': [
        {
            name: 'open',
            type: 'boolean = false',
        },
        {
            name: 'placement',
            type: "'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'anchor',
            type: 'HTMLElement',
            optional: true,
        },
    ],
    'mm-portfolio-item': [
        {
            name: 'layout',
            type: "'grid' | 'list' = 'grid'",
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'src',
            type: 'string',
            optional: true,
        },
        {
            name: 'alt',
            type: 'string',
            optional: true,
        },
        {
            name: 'badge',
            type: 'string',
            optional: true,
        },
        {
            name: 'datetime',
            type: 'string',
            optional: true,
        },
        {
            name: 'aria-expanded',
            type: "'true' | 'false'",
            optional: true,
        },
        {
            name: 'aria-haspopup',
            type: "'true' | 'false' | 'menu' | 'listbox' | 'tree' | 'grid' | 'dialog'",
            optional: true,
        },
        {
            name: 'aria-controls',
            type: 'AriaIdRef',
            optional: true,
        },
        {
            name: 'keywords',
            type: 'string[] = []',
        },
    ],
    'mm-post-feature': [
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'thumbnail',
            type: 'string',
            optional: true,
        },
        {
            name: 'title',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'date',
            type: 'string',
            optional: true,
        },
    ],
    'mm-post-item': [
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'thumbnail',
            type: 'string',
            optional: true,
        },
        {
            name: 'title',
            type: 'string',
            optional: true,
        },
        {
            name: 'category',
            type: 'string',
            optional: true,
        },
        {
            name: 'date',
            type: 'string',
            optional: true,
        },
    ],
    'mm-post-list': [],
    'mm-post-pager': [
        {
            name: 'previous',
            type: 'PostPagerItem',
            optional: true,
        },
        {
            name: 'next',
            type: 'PostPagerItem',
            optional: true,
        },
    ],
    'mm-post-paywall': [],
    'mm-prev-button': [
        {
            name: 'tooltip-placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'size',
            type: "'small' | 'medium' = 'medium'",
        },
    ],
    'mm-pricing-card': [
        {
            name: 'plan',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'price',
            type: 'string',
            optional: true,
        },
        {
            name: 'period',
            type: 'string',
            optional: true,
        },
        {
            name: 'features',
            type: 'string[] = []',
        },
    ],
    'mm-pricing-card-group': [],
    'mm-product-price': [
        {
            name: 'size',
            type: "'small' | 'medium' | 'large' = 'medium'",
        },
        {
            name: 'price',
            type: 'string',
            optional: true,
        },
        {
            name: 'original-price',
            type: 'string',
            optional: true,
        },
        {
            name: 'discount',
            type: 'string',
            optional: true,
        },
    ],
    'mm-product-purchase-bar': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'option',
            type: 'string',
            optional: true,
        },
        {
            name: 'image-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'price',
            type: 'string',
            optional: true,
        },
        {
            name: 'original-price',
            type: 'string',
            optional: true,
        },
        {
            name: 'discount',
            type: 'string',
            optional: true,
        },
    ],
    'mm-progress-dot': [
        {
            name: 'variant',
            type: "'todo' | 'in-progress' | 'done' | 'blocked' = 'todo'",
        },
    ],
    'mm-prompt-input': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'placeholder',
            type: "string = 'Ask me anything...'",
        },
        {
            name: 'model',
            type: "string = 'claude-sonnet'",
        },
        {
            name: 'submit-label',
            type: "string = '전송'",
        },
        {
            name: 'loading',
            type: 'boolean = false',
        },
    ],
    'mm-radio': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'medium' | 'large' = 'medium'",
        },
        {
            name: 'checked',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-radio-card': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'checked',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-radio-card-group': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'legend',
            type: 'string',
            optional: true,
        },
    ],
    'mm-radio-group': [
        {
            name: 'options',
            type: 'OptionItem[] = []',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'medium' | 'large' = 'medium'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'legend',
            type: 'string',
            optional: true,
        },
    ],
    'mm-radius-picker': [],
    'mm-read-more-button': [
        {
            name: 'aria-expanded',
            type: "'true' | 'false' = 'false'",
        },
        {
            name: 'aria-controls',
            type: 'AriaIdRef',
            optional: true,
        },
        {
            name: 'more-label',
            type: "string = '더 보기'",
        },
    ],
    'mm-read-more-paragraph': [
        {
            name: 'content',
            type: 'string',
            optional: true,
        },
        {
            name: 'max-length',
            type: 'number = 100',
        },
    ],
    'mm-recent-search-list': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'keywords',
            type: 'string[] = []',
        },
    ],
    'mm-result': [
        {
            name: 'avatar-icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'role',
            type: "'alert' | 'status' = 'status'",
        },
        {
            name: 'primaryAction',
            type: 'ActionConfig',
            optional: true,
        },
        {
            name: 'secondaryAction',
            type: 'ActionConfig',
            optional: true,
        },
    ],
    'mm-reveal-button': [
        {
            name: 'revealed',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-review-item': [
        {
            name: 'rating',
            type: 'number = 5',
        },
        {
            name: 'content',
            type: 'string',
            optional: true,
        },
        {
            name: 'author',
            type: 'string',
            optional: true,
        },
        {
            name: 'datetime',
            type: 'string',
            optional: true,
        },
    ],
    'mm-review-summary': [
        {
            name: 'rating',
            type: 'number = 0',
        },
        {
            name: 'review-count',
            type: 'number = 0',
        },
    ],
    'mm-scroll': [
        {
            name: 'direction',
            type: "'row' | 'column' = 'row'",
        },
        {
            name: 'gap',
            type: "'16' | '12' | '8' | '6' | '0' | '1' | '2' | '3' | '4' | 'section'",
            optional: true,
        },
        {
            name: 'hide-scrollbar',
            type: 'boolean = false',
        },
    ],
    'mm-scroll-hint': [
        {
            name: 'placement',
            type: "'start' | 'end' = 'end'",
        },
        {
            name: 'size',
            type: "'small' | 'medium' = 'medium'",
        },
    ],
    'mm-search-result-list': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'results',
            type: 'SearchResult[] = []',
        },
    ],
    'mm-search-suggestion': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-search-suggestion-group': [],
    'mm-searchfield': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'placeholder',
            type: 'string',
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'size',
            type: "'small' | 'medium' = 'medium'",
        },
    ],
    'mm-select': [
        {
            name: 'options',
            type: 'OptionItem[] = []',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'variant',
            type: "'tertiary' | 'ghost' = 'tertiary'",
        },
        {
            name: 'placement',
            type: "'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-select-listbox': [],
    'mm-select-option': [
        {
            name: 'size',
            type: "'small' | 'medium' = 'small'",
        },
        {
            name: 'tone',
            type: "'' | 'danger'",
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'tertiary'",
        },
        {
            name: 'avatar-shape',
            type: "'circle' | 'square' = 'square'",
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'selected',
            type: 'boolean = false',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
    ],
    'mm-selected-indicator': [
        {
            name: 'selected',
            type: 'boolean = false',
        },
    ],
    'mm-separator': [
        {
            name: 'variant',
            type: "'element' | 'section' = 'element'",
        },
    ],
    'mm-setting-item': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-sheet': [
        {
            name: 'open',
            type: 'boolean = false',
        },
        {
            name: 'aria-modal',
            type: "'true' | 'false' = 'true'",
        },
        {
            name: 'placement',
            type: "'top' | 'right' | 'bottom' | 'left' = 'bottom'",
        },
        {
            name: 'width',
            type: "'small' | 'large' = 'small'",
        },
        {
            name: 'height',
            type: 'string',
            optional: true,
        },
        {
            name: 'full-width',
            type: 'boolean = false',
        },
    ],
    'mm-sheet-body': [],
    'mm-sheet-footer': [
        {
            name: 'primaryAction',
            type: 'ActionConfig',
            optional: true,
        },
        {
            name: 'secondaryAction',
            type: 'ActionConfig',
            optional: true,
        },
    ],
    'mm-sheet-header': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
    ],
    'mm-show-more-button': [],
    'mm-sidebar': [
        {
            name: 'open',
            type: 'boolean = false',
        },
    ],
    'mm-sidebar-page-link': [
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'emoji',
            type: 'string',
            optional: true,
        },
    ],
    'mm-sidebar-section': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'open',
            type: 'boolean = false',
        },
    ],
    'mm-sidebar-user-menu': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
    ],
    'mm-social-auth-button': [
        {
            name: 'provider',
            type: "'apple' | 'facebook' | 'google' = 'facebook'",
        },
    ],
    'mm-social-links': [
        {
            name: 'github',
            type: 'string',
            optional: true,
        },
        {
            name: 'pinterest',
            type: 'string',
            optional: true,
        },
        {
            name: 'facebook',
            type: 'string',
            optional: true,
        },
        {
            name: 'notion',
            type: 'string',
            optional: true,
        },
        {
            name: 'compact',
            type: 'boolean = false',
        },
    ],
    'mm-sort-selector': [
        {
            name: 'value',
            type: "'latest' | 'oldest' = 'latest'",
        },
    ],
    'mm-spinner': [
        {
            name: 'variant',
            type: "'element' | 'section' = 'element'",
        },
        {
            name: 'label',
            type: "string = '로딩 중'",
        },
    ],
    'mm-status-dot': [
        {
            name: 'variant',
            type: "'live' | 'online' | 'new' | 'unread' = 'online'",
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-status-message': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'message',
            type: 'string',
            optional: true,
        },
    ],
    'mm-status-tag': [
        {
            name: 'variant',
            type: "'success' | 'warning' | 'error' | 'info' | 'neutral' = 'neutral'",
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-step': [
        {
            name: 'orientation',
            type: "'horizontal' | 'vertical' = 'horizontal'",
        },
    ],
    'mm-step-item': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'active',
            type: 'boolean = false',
        },
        {
            name: 'aria-current',
            type: "'true' | 'false' | 'page' | 'step' | 'location' | 'date' | 'time'",
            optional: true,
        },
    ],
    'mm-surface': [
        {
            name: 'variant',
            type: "'ghost' | 'paper' | 'outlined' | 'filled' | 'elevated'",
            optional: true,
        },
        {
            name: 'radius',
            type: "'default' | 'large'",
            optional: true,
        },
        {
            name: 'density',
            type: "'default' | 'compact'",
            optional: true,
        },
    ],
    'mm-switch': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'checked',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
    ],
    'mm-tab': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
    ],
    'mm-tab-list': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'variant',
            type: "'line' | 'pill' | 'text' = 'line'",
        },
        {
            name: 'search-param',
            type: 'string',
            optional: true,
        },
    ],
    'mm-tab-panel': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
    ],
    'mm-table': [
        {
            name: 'caption',
            type: 'string',
            optional: true,
        },
        {
            name: 'rows',
            type: 'unknown',
        },
        {
            name: 'columns',
            type: 'TableColumn[] = []',
        },
        {
            name: 'height',
            type: 'string',
            optional: true,
        },
    ],
    'mm-tag': [
        {
            name: 'tone',
            type: "'default' | 'gold' | 'green' | 'yellow' | 'red' | 'blue' | 'purple' | 'pink' | 'orange' | 'cyan' = 'default'",
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
    ],
    'mm-tag-group': [],
    'mm-task-status': [
        {
            name: 'variant',
            type: "'running' | 'success' | 'warning' | 'error' = 'running'",
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'meta',
            type: 'string[] = []',
        },
    ],
    'mm-terms-agreement': [
        {
            name: 'options',
            type: 'OptionItem[] = []',
        },
        {
            name: 'values',
            type: 'string[] = []',
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
    ],
    'mm-text': [
        {
            name: 'as',
            type: "'span' | 'p' | 'strong' | 'time' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' = 'span'",
        },
        {
            name: 'size',
            type: "'32' | '24' | '18' | '14' | '12' = '14'",
        },
        {
            name: 'weight',
            type: "'medium' | 'bold' = 'medium'",
        },
        {
            name: 'color',
            type: "'inherit' | 'light' | 'danger' = 'inherit'",
        },
        {
            name: 'centered',
            type: 'boolean = false',
        },
        {
            name: 'max-lines',
            type: "'' | '1' | '2' | '3'",
            optional: true,
        },
    ],
    'mm-text-block': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'level',
            type: "'1' | '2' | '3' | '4' | '5' = '1'",
        },
        {
            name: 'centered',
            type: 'boolean = false',
        },
    ],
    'mm-text-list': [
        {
            name: 'texts',
            type: 'Array<string | TemplateResult> = []',
        },
        {
            name: 'variant',
            type: "'number' | 'check' = 'check'",
        },
    ],
    'mm-textarea': [
        {
            name: 'input-id',
            type: 'string',
            optional: true,
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'placeholder',
            type: 'string',
            optional: true,
        },
        {
            name: 'aria-describedby',
            type: 'AriaIdRef',
            optional: true,
        },
        {
            name: 'rows',
            type: 'number = 2',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-invalid',
            type: "'true' | 'false' | 'grammar' | 'spelling'",
            optional: true,
        },
    ],
    'mm-textarea-field': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'placeholder',
            type: 'string',
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'rows',
            type: 'number = 2',
        },
        {
            name: 'optional',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-invalid',
            type: "'true' | 'false' | 'grammar' | 'spelling'",
            optional: true,
        },
    ],
    'mm-textfield': [
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'placeholder',
            type: 'string',
            optional: true,
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'validation-text',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'small' | 'medium' = 'medium'",
        },
        {
            name: 'optional',
            type: 'boolean = false',
        },
        {
            name: 'hidden-label',
            type: 'boolean = false',
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-invalid',
            type: "'true' | 'false' | 'grammar' | 'spelling'",
            optional: true,
        },
        {
            name: 'type',
            type: "'text' | 'search' | 'tel' | 'url' | 'email' | 'password' | 'number' | 'date' | 'time' | 'datetime-local' | 'month' | 'week' | 'color' | 'hidden' = 'text'",
        },
    ],
    'mm-textfield-description': [],
    'mm-textfield-label': [
        {
            name: 'for',
            type: 'string',
            optional: true,
        },
        {
            name: 'optional',
            type: 'boolean = false',
        },
    ],
    'mm-textfield-validation': [],
    'mm-theme-selector': [
        {
            name: 'value',
            type: "'light' | 'dark' | 'brutal' | 'glass' = 'light'",
        },
    ],
    'mm-thumbnail': [
        {
            name: 'src',
            type: 'string',
            optional: true,
        },
        {
            name: 'alt',
            type: 'string',
            optional: true,
        },
        {
            name: 'ratio',
            type: "'1:1' | '16:9' | '4:3' | 'full' = '16:9'",
        },
        {
            name: 'loading',
            type: "'eager' | 'lazy' = 'lazy'",
        },
        {
            name: 'fetchpriority',
            type: "'high' | 'low' | 'auto' = 'auto'",
        },
        {
            name: 'href',
            type: 'string',
            optional: true,
        },
        {
            name: 'caption',
            type: 'string',
            optional: true,
        },
    ],
    'mm-timeline': [],
    'mm-timeline-item': [
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-to-top-button': [],
    'mm-toast': [
        {
            name: 'open',
            type: 'boolean = false',
        },
    ],
    'mm-toggle-button': [
        {
            name: 'pressed',
            type: 'boolean = false',
        },
        {
            name: 'pressed-label',
            type: 'string',
            optional: true,
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'disabled',
            type: 'boolean = false',
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-toggle-button-group': [
        {
            name: 'options',
            type: 'OptionItem[] = []',
        },
        {
            name: 'value',
            type: 'string',
            optional: true,
        },
        {
            name: 'stretch',
            type: 'boolean = false',
        },
        {
            name: 'hidden-label',
            type: 'boolean = false',
        },
        {
            name: 'orientation',
            type: "'horizontal' | 'vertical' = 'horizontal'",
        },
    ],
    'mm-token': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'showcategory',
            type: 'boolean = true',
        },
    ],
    'mm-token-group': [],
    'mm-token-item': [
        {
            name: 'key',
            type: 'string',
            optional: true,
        },
    ],
    'mm-token-section': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
    ],
    'mm-token-stage': [],
    'mm-token-swatches': [
        {
            name: 'swatches',
            type: 'string[] = []',
        },
        {
            name: 'gap',
            type: "'16' | '12' | '8' | '6' | '0' | '1' | '2' | '3' | '4' | 'section' = '4'",
        },
    ],
    'mm-tooltip': [
        {
            name: 'content',
            type: 'string',
            optional: true,
        },
        {
            name: 'placement',
            type: "'bottom-start' | 'bottom' | 'bottom-end' = 'bottom-start'",
        },
        {
            name: 'open',
            type: 'boolean = false',
        },
    ],
    'mm-tooltip-bubble': [],
    'mm-top-bar': [
        {
            name: 'heading',
            type: 'string',
            optional: true,
        },
        {
            name: 'nav',
            type: "'back' | 'close' = 'back'",
        },
    ],
    'mm-type-specimen': [
        {
            name: 'size',
            type: 'string',
            optional: true,
        },
    ],
    'mm-typing-indicator': [
        {
            name: 'aria-label',
            type: "string = '입력 중'",
        },
    ],
    'mm-ui-placeholder': [],
    'mm-user-avatar': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'src',
            type: 'string',
            optional: true,
        },
        {
            name: 'size',
            type: "'80' | '48' | '40' | '32' = '40'",
        },
        {
            name: 'online',
            type: 'boolean = false',
        },
        {
            name: 'aria-label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-user-item': [
        {
            name: 'size',
            type: "'small' | 'medium' | 'large' = 'small'",
        },
        {
            name: 'label',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'icon',
            type: 'IconName',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-variant',
            type: "'primary' | 'secondary' | 'tertiary' = 'primary'",
        },
    ],
    'mm-user-snippet': [
        {
            name: 'name',
            type: 'string',
            optional: true,
        },
        {
            name: 'phone',
            type: 'string',
            optional: true,
        },
        {
            name: 'email',
            type: 'string',
            optional: true,
        },
        {
            name: 'description',
            type: 'string',
            optional: true,
        },
        {
            name: 'avatar-src',
            type: 'string',
            optional: true,
        },
        {
            name: 'tag-label',
            type: 'string',
            optional: true,
        },
    ],
    'mm-view-mode-switcher': [
        {
            name: 'value',
            type: "'grid' | 'list' = 'grid'",
        },
    ],
};
exports.componentManifest = manifest;
//# sourceMappingURL=data:application/json;base64,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